<span>
  &copy; {{ currentYear }} <a href="https://twaice.com/" rel="noopener" target="_blank">TWAICE Technologies GmbH</a> |
  <a routerLink="/privacy-policy" data-test="privacy-policy-link">Privacy Policy</a>
</span>
<span class="version">
  {{ appVersion }}
</span>
